import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import React from 'react';

function ReactModalAdapter({ className, modalClassName, ...props }) {
  return <ReactModal className={modalClassName} portalClassName={className} {...props} />;
}

ReactModalAdapter.propTypes = {
  modalClassName: PropTypes.string,
  className: PropTypes.string
};

const StyledLightbox = styled(ReactModalAdapter).attrs({
  overlayClassName: 'modal__overlay',
  modalClassName: 'modal__content'
})`
  .modal__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* mobile viewport bug fix */
    min-height: -webkit-fill-available;
    background: rgba(0, 0, 0, 0.95);
    z-index: 100;
  }

  .modal__content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export default StyledLightbox;
